import Http from '../../../core/Http';
import { api } from '../../../lib/api';

const BASE_URL = '/api/system/glow/terms';
const PUBLIC_LATEST_URL = '/api/public/glow/terms/latest';

export const fetchTermsList = async (termsDstnCd) => {
  return api.get(BASE_URL, { params: { termsDstnCd } });
};

/** 비로그인 최신 약관 (USER_TERMS | USER_PRIVATE). 없으면 null */
export const fetchLatestTermsPublic = async (termsDstnCd, lang, { _fallbackKo = false } = {}) => {
  try {
    const params = { termsDstnCd };
    if (lang && !_fallbackKo) {
      params.lang = lang;
    }
    const data = await Http.get(PUBLIC_LATEST_URL, { params });
    if (data && typeof data === 'object') {
      return data;
    }
    return null;
  } catch (e) {
    if (e.response?.status === 204) {
      return null;
    }
    const status = e.response?.status;
    if (lang && !_fallbackKo && status >= 500) {
      return fetchLatestTermsPublic(termsDstnCd, lang, { _fallbackKo: true });
    }
    throw e;
  }
};

export const saveTerms = async (payload) => {
  return api.post(BASE_URL, payload);
};

